export interface IFooterButtons{
    terms: {label: string, url: string},
    privacy: {label: string, url: string},
    rights: {label: string, url: string}
}